import React, { useEffect, useState } from "react";
// import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";
// import { leaves } from "./leaves";
// const { MerkleTree } = require("merkletreejs");
// const keccak256 = require("keccak256");

// const truncate = (input, len) =>
//   input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
  padding: 10px;
  border-radius: 50px;
  border: none;
  background-color: var(--secondary);
  padding: 10px;
  font-weight: bold;
  color: var(--secondary-text);
  width: 100px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 0%;
  border: none;
  background-color: #000000;
  padding: 10px;
  font-weight: bold;
  font-size: 15px;
  color: var(--primary-text);
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledLogo = styled.img`
  width: 200px;
  @media (min-width: 500px) {
    width: 225px;
  }
  @media (min-width: 900px) {
    width: 250px;
  }

  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledImg = styled.img`
  box-shadow: 0px 5px 11px 2px rgba(0, 0, 0, 0.7);
  border: 4px solid #000000;
  background-color: var(--accent);
  border-radius: 5%;
  width: 200px;
  @media (min-width: 900px) {
    width: 350px;
  }
  @media (min-width: 1000px) {
    width: 450px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: var(--secondary);
  text-decoration: none;
`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [totalOldMint, setOldMint] = useState(0);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Connect wallet to mint.`);
  const [mintAmount, setMintAmount] = useState(1);

  // const [proof, setProof] = useState();
  // const [whitelisted, setWhitelisted] = useState(false);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const Web3 = require("web3");
  const web3 = new Web3(new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/7bc874b78725412482602725f17acf56"));
  
  const contractAddress = "0xFc6f1dDf79d3589d4d3Cf3107cAD96FA8EB3de80";
  const contractABI = [
    {
      "constant": true,
      "inputs": [
        {
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "name": "balance",
          "type": "uint256"
        }
      ],
      "payable": false,
      "stateMutability": "view",
      "type": "function"
    }
  ];
  
  const contract = new web3.eth.Contract(contractABI, contractAddress);
  
  async function getBalance(walletAddress) {
    const balance = await contract.methods.balanceOf(walletAddress).call();
    console.log(`Balance: ${balance} tokens`);
  }
  
  const claimHolderNFTs = async () => {
    let supply = await blockchain.smartContract.methods.totalSupply().call((err, result) => {
      if(err){
        console.error('Error: ', err);
        // handle the error here
      }

      // console.log("Supply: ", supply);
      // console.log("Result: ", result);

      // You can add supply now to whatever part
      // of your page you want it displayed
    });
 
    getMintHolder();
    let cost = 0;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost);
    let totalGasLimit = String(gasLimit);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);

    let currentMinted = await contract.methods.balanceOf(blockchain.account).call((err, result) => {
      if(err)
      {
        console.error('Error: ', err);
      }
      
      console.log("Total Old Mints: ", result);
    })   

    // getBalance("0x7B369b5C69c10832e24c8f3b8090FeF189080710");

    console.log(currentMinted);

    setFeedback(`Minting your tokens...`);
    setClaimingNft(true);
      blockchain.smartContract.methods
      .HolderClaim("0x7B369b5C69c10832e24c8f3b8090FeF189080710", currentMinted)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Transaction cancelled.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `Congratulations, ${CONFIG.NFT_NAME} is yours! Please go visit Opensea.io to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  }

  const claimNFTs = async () => {
    let cost = 0;
    let supply = await blockchain.smartContract.methods.totalSupply().call((err, result) => {
      if(err){
        console.error('Error: ', err);
        // handle the error here
      }

      // console.log("Supply: ", supply);
      // console.log("Result: ", result);

      // You can add supply now to whatever part
      // of your page you want it displayed
    });

    // let currentMinted = await blockchain.smartContract.methods.balanceOf(blockchain.account).call((err, result) => {
    //   if(err)
    //   {
    //     console.error('Error: ', err);
    //   }

    //   console.log("New mint total =", parseInt(result) + mintAmount); 

      
    // })    

    // COMMENT THIS OUT FOR PUBLIC
    // if(parseInt(currentMinted) + mintAmount > 10)
    // {
    //   setFeedback("Transaction cancelled. Max claimed for WL wallet.");
    //   setClaimingNft(false);
    //   return;
    // }
    console.log("Correct Supply: ", supply);

    let price = 0.0015;

    console.log("Actual Cost: ", mintAmount * (price * 10e17));
    cost = mintAmount * (price * 10e17);

    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost);
    let totalGasLimit = String(gasLimit);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your tokens...`);
    setClaimingNft(true);
      blockchain.smartContract.methods
      .Mint(mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Transaction cancelled.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `Congratulations, ${CONFIG.NFT_NAME} is yours! Please go visit Opensea.io to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const decrementMintAmount = async () => {

    // let currentMinted = await blockchain.smartContract.methods.balanceOf(blockchain.account).call((err, result) => {
    //   if(err)
    //   {
    //     console.error('Error: ', err);
    //   }
      
    //   console.log("Total Owned: ", result);
    // })   

    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }

    // if(currentMinted >= 5)
    // {
    //   newMintAmount = 0;
    // }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = async () => {

    let newMintAmount = mintAmount + 1;
    if(newMintAmount > 10)
    {
      newMintAmount = 10;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
      blockchain.smartContract.methods.publicMinting().call((err, result) => {
      if(err)
      {
        console.error('Error: ', err);
      }
      
      console.log("Public mint: ", result);
    })   

    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);
 
    const [loaded, setLoaded] = useState(false);
    const getMintHolder = () => {
      const list = Promise.all(
        [1].map(async (number) => {
          const response = await fetch(
            `https://api.opensea.io/api/v1/assets?owner=${blockchain.account}&collection_slug=ragdollz-nfts`
          );
          if (response.ok) {
            return response.json();
          } else {
            location.reload();
          }
        })
      );
      list
        .then(function (data) {
          setOldMint(data[0].length);
          console.log("Total Old NFTs: ", totalOldMint);
        })
        .then(function () {
          setLoaded(true);
        });
    };

  return (
    <s.Screen>
      <s.Header
        flex={1}
        ai={"center"}
      >
        <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}
        // <StyledLink href={"/"}

        style={{
            textAlign: "left",
            color: "#FFFFFF",
            padding: 20,
            fontSize: 25,
            textDecoration: "none",
          }}>
                  RAGDOLLZ REBORN - MINTING PAGE
        </StyledLink>
      </s.Header>
      <s.Container
        flex={1}
        ai={"center"}
        style={{ padding: 20, backgroundColor: "var(--primary)" }}
        image={CONFIG.SHOW_BACKGROUND ? "/config/images/bg.png" : null}
        backgroundColor={"#000000"}
      >
        <a href={CONFIG.MARKETPLACE_LINK}> 
          <StyledLogo alt={"logo"} src={"/config/images/logo.png"} />
        </a>
        <ResponsiveWrapper flex={1} style={{ padding: 0 }} test>
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <StyledImg alt={"example"} src={"/config/images/example.gif"} />
            <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 20,
                fontWeight: "bold",
                color: "#FFFFFF",
                paddingTop: 15,
              }}
            >
              Mint Price: 0.0015 ETH! <br/>
              10 mints per transaction. Public Mint!
            </s.TextTitle>

            <s.TextDescription
              style={{
                textAlign: "center",
                color: "var(--primary-text)",
              }}
            >
              </s.TextDescription>
          </s.Container>
          <s.SpacerLarge />
          <s.Container
            flex={2}
            jc={"center"}
            ai={"center"}
            style={{
              backgroundColor: "var(--accent)",
              padding: 24,
              borderRadius: 5,
              border: "4px solid var(--secondary)",
              boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
            }}
          >
            {/* <a href={CONFIG.MARKETPLACE_LINK}> 
          <StyledLogo alt={"logo"} src={"/config/images/logo.png"} />
        </a> */}

             <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 50,
                fontWeight: "bold",
                color: "var(--accent-text)",
              }}
            >
              {data.totalSupply} / {CONFIG.MAX_SUPPLY}
            </s.TextTitle>
            <s.TextDescription
              style={{
                textAlign: "center",
                color: "var(--primary-text)",
              }}
            >
              </s.TextDescription>
              <StyledLink target={"_blank"} href={CONFIG.SCAN_LINK+"#writeContract"}>
                {">> Or Mint on Contract <<"}
                </StyledLink>
              <s.TextDescription
              style={{
                textAlign: "center",
                color: "var(--primary)",
              }}
              >
            </s.TextDescription>
            
            <span
              style={{
                textAlign: "center",
                color: "var(--link)",
              }}
            >
              <StyledButton
                style={{
                  margin: "5px",
                  borderRadius: 5,
                  width: 200,
                }}
                onClick={(e) => {
                  window.open(CONFIG.MARKETPLACE_LINK, "_blank");
                }}
              >
                {CONFIG.MARKETPLACE}
              </StyledButton>
            </span>
            <s.SpacerSmall />
            {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
              <>
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  SOLD OUT!
                </s.TextTitle>
                <s.TextDescription
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  Ragdollz Reborn are still available on OpenSea.
                </s.TextDescription>
                <s.SpacerSmall />
                <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
                  {CONFIG.MARKETPLACE}
                </StyledLink>
              </>
            ) : (
              <>

                <s.SpacerXSmall />
                <s.SpacerSmall />
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <s.Container ai={"center"} jc={"center"}>
             
                    <s.SpacerSmall />
                    <StyledButton
                      // ACTIVATE ON JUNE24TH
                      onClick={(e) => {
                          e.preventDefault();
                          dispatch(connect());
                          getData();
                      }}
                      style={{
                        borderRadius: 5,
                        width: 280,
                        height: 100,
                        fontSize: 25,
                      }}
                      //CHANGE TO CONNECT WALLET
                    >
                      
                      CONNECT WALLET
                    </StyledButton>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}
                        >
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>
                ) : (
                  <>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      Wallet Connected | <StyledLink target={"_blank"} 
                    style={{ color: "#ADD8E6"}}
                    href={"https://twitter.com/intent/tweet?text=Ragdollz%20Reborn%20is%20live%20with%20a%20new%20mint!%20Check%20it%20out%20at%20https://ragdollzreborn.netlify.app/%20%23Ethereum%20%23Minting%20%23CryptoCollectibles"}>
                {"Tell your friends on Twitter!"}
                </StyledLink>
                
                    </s.TextDescription>
                    <s.SpacerMedium />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <StyledRoundButton
                        style={{ lineHeight: 0.4 }}
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          decrementMintAmount();
                        }}
                      >
                        -
                      </StyledRoundButton>
                      <s.SpacerMedium />
                      <s.TextDescription
                        style={{
                          textAlign: "center",
                          color: "var(--accent-text)",
                        }}
                      >
                        {mintAmount}
                      </s.TextDescription>
                      <s.SpacerMedium />
                      <StyledRoundButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          incrementMintAmount();
                        }}
                        
                      >
                        +
                      </StyledRoundButton>
                    </s.Container>
                    <s.SpacerSmall />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                    {/* <StyledButton
                        disabled={claimingNft ? 1 : 0}
                        
                        onClick={(e) => {
                            e.preventDefault();
                            claimHolderNFTs();
                            getData();
                        }}
                        style={{
                          borderRadius: 5,
                          width: 200,
                        }}
                      >
                        {claimingNft ? "CLAIMING RAGDOLLZ..." : "CLAIM"}
                      </StyledButton>
                      <s.SpacerSmall /> */}

                      <StyledButton
                        disabled={claimingNft ? 1 : 0}
                        //JUNE 24TH
                        onClick={(e) => {
                            e.preventDefault();
                            claimNFTs();
                            getData();
                        }}
                        style={{
                          borderRadius: 5,
                          width: 200,
                        }}
                      >
                        {claimingNft ? "MINTING YOUR RAGDOLLZ..." : "MINT"}
                      </StyledButton>
                    </s.Container>
                  </>
                )}
              </>
            )}
            {/* <s.SpacerMedium /> */}
            <s.SpacerXSmall />
          </s.Container>
          <s.SpacerLarge />
          
        </ResponsiveWrapper>
        <s.Container jc={"center"} ai={"center"} style={{ width: "100%" }}>
          <s.TextDescription
            style={{
              textAlign: "center",
              color: "#FFFFFF",
            }}
          >
            Make sure you are connected to the right network (
            {CONFIG.NETWORK.NAME} Mainnet). Once you mint, you cannot undo it. We've pre-set your gas, it's probably going to cost less.
          </s.TextDescription>
        </s.Container>
      </s.Container>
      
      
    </s.Screen>
  );
}

export default App;
